const origin = window.location.origin;

// 测试环境
export const isTest = /.qa|(\.qa)/.test(origin);

// 开发环境
export const isDev = /.dev|(\.dev)/.test(origin) || window.location.port != '';

// release环境
export const isRelease =
  /.release|(\.release)/.test(origin) || window.location.port != '';

// 生产环境
export const isProd = !(isTest || isDev || isRelease);

// 获取当前运行环境
export const getCurrentEvn = () => {
  if (isTest) return 'test';
  if (isDev) return 'dev';
  if (isRelease) return 'release';
  return 'prod';
};
